import axios from "axios";
import Qs from "qs";
import {Loading, Message} from "element-ui";
import {path} from "./ServicePath";
import router from "../../router";
import store from "@/store";
import {clearDashboardAuth, getDashboardToken} from "@/utils/dashboardAuth";

const axiosInfo = {
  loading: null,
  token: {}
};
const baseURL = "";
const AUTH_LOGIN_PATH = "/auth/login";
// 超时时间
const TIMEOUT = 600000;
// const TIMEOUT = 30000;
// const TIMEOUT = 10000;

axios.defaults.withCredentials = true;

/**
 * 取消重复请求
 * @param config
 */
const removePending = config => {
  for (let k in store.state.auth.axiosPromiseCancel) {
    if (store.state.auth.axiosPromiseCancel[k].u === config.url && store.state.auth.axiosPromiseCancel[k].d === JSON.stringify(config.data || config.params)) {
      //当前请求在数组中存在时执行函数体
      store.commit("auth/clearCommonAxiosPromiseCancel", k);
    }
  }
};

const isAuthLoginRequest = config => config && config.url && config.url.indexOf(AUTH_LOGIN_PATH) > -1;
const isRawResponseRequest = config => {
  if (!config || !config.url) {
    return false;
  }
  return config.url.indexOf("/amap-geocode") > -1;
};

const redirectToLogin = () => {
  const currentRoute = router.currentRoute || {};
  const currentPath = currentRoute.fullPath || "/";

  if (currentPath !== "/login") {
    router.replace({
      path: "/login",
      query: { redirect: currentPath }
    }).catch(() => {});
  }
};

/**
 * 请求拦截器
 */
axios.interceptors.request.use(
  config => requestInterceptors(config),
  error => Promise.reject(error)
);
/**
 * 响应拦截器
 */
axios.interceptors.response.use(
  response => {
    removePending(response.config);
    loadingClose();
    if (response.status >= 200 && response.status < 300) {
      store.commit("auth/add_res_num");
      if (response.data && response.data.token) {
        store.commit("auth/setToken", response.data.token);
      }
      if (!isRawResponseRequest(response.config) && response.data && response.data.status && response.data.status !== 200) {
        switch (response.data.status) {
          case 302:
            // window.location.href = "/ics/operation";
            break;
          default:
            Message({
              message: response.data.message || "Error",
              type: "error"
            });
        }
        return Promise.reject(new Error(response.data.message || "Error"));
      }
      return response;
    }
    return response;
  },
  error => {
    store.commit("auth/add_res_num");
    if (axios.isCancel(error)) {
      // 为了终结promise链 就是实际请求 不会走到.catch(rej=>{});这样就不会触发错误提示之类了。
      return new Promise(() => {
      });
    }
    if (error.response && error.response.status === 401) {
      const data = error.response.data || {};

      if (data.code === "DASHBOARD_UNAUTHORIZED" && !isAuthLoginRequest(error.config)) {
        clearDashboardAuth();
        Message.error("登录已过期，请重新登录");
        redirectToLogin();
      }
    }
    if (error.response && error.response.status === 500) {
      Message.error("服务器繁忙，请稍后重试");
    }
    return Promise.reject(error);
  }
);

/**
 * 请求拦截器处理
 * @param {*} config
 */
function requestInterceptors(config) {
  config.headers = config.headers || {};
  const dashboardToken = getDashboardToken();

  if (dashboardToken) {
    config.headers["X-Dashboard-Token"] = dashboardToken;
  }
  // 发起请求时,取消当前重复请求
  removePending(config);
  // 发起请求时保存当前所有请求
  config.cancelToken = new axios.CancelToken(cancel => {
    if (config.url === "/ics/micro/dashboard/get_event_list" && config.params.latest_period === 10) {
    } else {
      store.commit("auth/add_req_num");
    }
    store.commit("auth/setAxiosPromiseCancel", {
      u: config.url,
      f: cancel,
      d: JSON.stringify(config.data || config.params)
    });
  });
  const removeEmpty = obj => {
    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === "object") {
        removeEmpty(obj[key]);
      } else if (
        obj[key] === null
                || obj[key] === ""
                || obj[key] === undefined
      ) {
        delete obj[key];
      }
    });
  };

  removeEmpty(config.data || {});
  const contentType = config.headers["Content-Type"] || "";

  if (contentType.indexOf("application/json") > -1) {
    config.data = JSON.stringify(config.data);
  } else if (contentType.indexOf("multipart/form-data") > -1) {
    let data = new FormData();

    for (let key of Object.keys(config.data)) {
      data.append(key, config.data[key]);
    }
    config.data = data;
  } else {
    config.data = Qs.stringify(config.data);
  }
  return config;
}

/**
 * 处理loading
 * @param {*} loadingFlag
 */
const processLoading = loadingFlag => {
  if (loadingFlag) {
    axiosInfo.loading = Loading.service({
      text: "加载中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.8)"
    });
  }
};
/**
 * 处理loading
 */
const loadingClose = () => {
  if (axiosInfo.loading) {
    axiosInfo.loading.close();
  }
};

/**
 * 处理url
 * @param {*} service
 * @param {*} url
 */
const processURL = (service, url) => {
  return `${service === false ? "" : baseURL + (path[service] || "")}${url}`;
};

/**
 * 处理token
 * @param {*} data
 */
const processToken = data => Object.assign({...axiosInfo.token}, data || {});

/**
 * 封装axios的get请求
 * @param {*} requestData
 */

function get(requestData) {
  return new Promise((resolve, reject) => {
    processLoading(requestData.loading);
    axios({
      method: "get",
      timeout: requestData.timeout !== undefined ? requestData.timeout : TIMEOUT,
      url: processURL(requestData.service, requestData.url),
      params:
                requestData.token === false
                  ? requestData.data
                  : processToken({...requestData.data}),
      headers: requestData.headers || {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    })
      .then(response => {
        store.commit("auth/setToken", response.data.token);
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      })
      .finally(() => {
        loadingClose();
      });
  });
}

/**
 * 封装axios的post请求
 * @param {*} requestData
 */
function post(requestData) {
  return new Promise((resolve, reject) => {
    processLoading(requestData.loading);
    axios({
      method: "post",
      timeout: requestData.timeout !== undefined ? requestData.timeout : TIMEOUT,
      url: processURL(requestData.service, requestData.url),
      data:
                requestData.token === false
                  ? requestData.data
                  : processToken({...requestData.data}),
      headers: requestData.headers || {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      })
      .finally(() => {
        loadingClose();
      });
  });
}

function all(methods) {
  return axios.all(methods);
}

/**
 * 设置token信息
 * @param {*} data
 */
const setToken = data => {
  axiosInfo.token = data;
};

/**
 * 清空token
 */
const clearToken = () => {
  axiosInfo.token = {};
};

export {get, post, all, setToken, clearToken};
